package org.mkui.canvas

import kotlinx.browser.window
import org.mkui.color.MkColor
import org.mkui.graphics.IDrawing
import org.w3c.dom.Document
import web.canvas.CanvasRenderingContext2D
import web.canvas.ID
import web.html.HTMLCanvasElement

class ElementalBufferedGWTLayer : CanvasRenderingContext2DLayer {
    private val iDrawing: IDrawing
    private var paletteProvider: PaletteProvider? = null
    private var color: MkColor? = null
    private var alpha: Double? = null
    private var width = 0
    private var height = 0
    private var image: HTMLCanvasElement?

    //    private Canvas screenImage;
    constructor(iDrawing: IDrawing) {
        this.iDrawing = iDrawing
        val document: Document = window.document
        image = document.createElement("canvas") as HTMLCanvasElement
        image!!.setAttribute("style", "width: 100%; height: 100%;")
        //        this.screenImage = Canvas.createIfSupported();;
    }

    constructor(iDrawing: IDrawing, paletteProvider: PaletteProvider?) {
        this.iDrawing = iDrawing
        val document: Document = window.document
        image = document.createElement("canvas") as HTMLCanvasElement
        image!!.setAttribute("style", "width: 100%; height: 100%;")
        //        this.screenImage = Canvas.createIfSupported();
        this.paletteProvider = paletteProvider
    }

    constructor(iDrawing: IDrawing, color: MkColor, alpha: Double?) {
        this.iDrawing = iDrawing
        val document: Document = window.document
        image = document.createElement("canvas") as HTMLCanvasElement
        image!!.setAttribute("style", "width: 100%; height: 100%;")
        this.color = color
        this.alpha = alpha
    }

    override fun prepare(width: Int, height: Int) {
        if (iDrawing.isActive && width > 0 && height > 0) {
            val g: CanvasRenderingContext2D? = image!!.getContext(CanvasRenderingContext2D.ID)
            println("Preparing to " + g + ", " + height + "x" + width + ": " + color)
            resize(width, height)
            ElementalDirectGWTLayer.draw(g!!, iDrawing, width.toDouble(), height.toDouble(), paletteProvider, color, alpha)

//            copySrcIntoDstAt(image, screenImage);
        }
    }

    fun resize(width: Int, height: Int) {
        if ((this.width != width || this.height != height) && width > 0 && height > 0) {
            println("Resizing " +  this.width + "x" + this.height + " -> " + width + "x" + height)
            image!!.width = width
            image!!.height = height
            //            screenImage.setCoordinateSpaceWidth(width);
//            screenImage.setCoordinateSpaceHeight(height);
            this.width = width
            this.height = height
        } else {
            println("Clearing " +  width + "x" + height + ": " + color)
            clear()
        }
    }

    fun clear() {
        if (image != null) {
            // This seems like a hack, but works better because it reset the graphic context
//            canvas.setCoordinateSpaceWidth(canvas.getOffsetWidth());
            val g: CanvasRenderingContext2D? = image!!.getContext(CanvasRenderingContext2D.ID)
            g!!.setTransform(1.0, 0.0, 0.0, 1.0, 0.0, 0.0)
            g!!.clearRect(0.0, 0.0, image!!.width.toDouble(), image!!.height.toDouble())
            //            GWTCanvas.clear(image);
        }
    }

    override fun render(g: CanvasRenderingContext2D) {
        if (iDrawing.isActive && image != null) {
            println("Rendering image " + image + ", " + image!!.width + "x" + image!!.height)
            g.drawImage(image!!, 0.0, 0.0)
        }
    }

    val drawing: IDrawing
        get() = iDrawing

    companion object {
//        private fun copySrcIntoDstAt(src: Canvas, dst: Canvas) {
////        GWTCanvas.clear(dst);
//            dst.getContext2d().drawImage(src.getCanvasElement(), 0, 0)
//        }
    }
}
